import { Div, RefBool, Link } from "@tblabs/truffle";
import { FaqField } from "../../../Models/Description/Faq/FaqField";
import { FaqPrinter } from "./FaqPrinter";
import { Center } from "../../Utils/Center";

/*
<div class="product-questions">
    <div class="product-questions__item">
        <div class="product-questions__box">
            <div class="product-questions__question">
                Co muszę mieć swojego aby korzystać z zestawu?
            </div>
            <div class="product-questions__answer">
                Generalnie nic. Potrzebny jest tylko jakikolwiek telefon z dostępem do internetu.
            </div>
        </div>
        <div data-orientation="horizontal" role="separator" class="product-questions__separator"></div>
    </div>
    <button class="product-questions__toggle">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down product-questions__icon">
            <path d="m6 9 6 6 6-6"></path>
        </svg>
        Pokaż wszystkie 13 pytań
    </button>
</div>
*/
export class FaqsPrinter extends Div
{
    constructor(field: FaqField)
    {
        super("product-questions");

        const expand = new RefBool();

        this.Append(
            ...field.Questions
                .Take(0, 3)
                .map(x => new FaqPrinter(x)),

            (field.Questions.Count > 3) && new Center(
                new Link(`▼ Pokaż wszystkie ${field.Questions.Count}`).Class("product-questions__toggle")
                    .OnClick(_ => { _.Hide(); expand.True(); })),

            new Div().Append(
                ...field.Questions
                    .Take(3, field.Questions.Count)
                    .map(x => new FaqPrinter(x)))
                .Visible(expand)
        )
    }
}
